module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_CYSTERNA_20.1aa18c5f.svg";